/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AccountManagerListRequest = {
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: AccountManagerListRequest.direction | null;
};

export namespace AccountManagerListRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

